export default __webpack_public_path__ + "fe2b86e48ea2cf2e490f08de7562ff7f.png";